module.exports = __webpack_public_path__ + "static/media/19ESCAP24.8bbb2dfd.jpg";